var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { FormField } from '../../form';
import { Switch } from '../switch';
import clsx from '../../utils/clsx';
export var SwitchField = React.forwardRef(function (props, ref) {
    var switchLabels = props.switchLabels, switchLabelPlacement = props.switchLabelPlacement, onBlur = props.onBlur, onChange = props.onChange, onValueChange = props.onValueChange, checked = props.checked, value = props.value, name = props.name, defaultChecked = props.defaultChecked, defaultValue = props.defaultValue, error = props.error, _a = props.SwitchProps, SwitchProps = _a === void 0 ? {} : _a, formFieldProps = __rest(props, ["switchLabels", "switchLabelPlacement", "onBlur", "onChange", "onValueChange", "checked", "value", "name", "defaultChecked", "defaultValue", "error", "SwitchProps"]);
    return (React.createElement(FormField, __assign({ ref: ref, error: error }, formFieldProps), function (_a) {
        var controlId = _a.controlId, helperTextId = _a.helperTextId, errorTextId = _a.errorTextId;
        return (React.createElement(Switch, __assign({ id: controlId, inputProps: {
                'aria-invalid': !!error,
                'aria-describedby': clsx(helperTextId, errorTextId),
            }, name: name, labelPlacement: switchLabelPlacement, onChange: onChange, onBlur: onBlur, defaultChecked: defaultChecked, checked: checked, value: value, labels: switchLabels, onValueChange: onValueChange }, SwitchProps)));
    }));
});
